import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { readSetupDraftFromUrl, rememberSetupDraft } from '@/utils/setupDraft';

// smartfi.ph "Download & Setup" arrives as /?setup=<id>. Remember it BEFORE any
// route guard runs: a visitor who is already signed in never sees the sign-in
// page (PublicRoute sends them straight to /home), so a note written there was
// lost and the wizard never opened (found on staging 2026-09-29).
{
   const draftId = readSetupDraftFromUrl();
   if (draftId) rememberSetupDraft(draftId);
}

// 2026-09-28: without a staleTime every mount and every window focus
// refetched EVERY query on the page — the admin panel fired 21 requests each
// time Ray tabbed back to it. 20 s is short enough that nothing reads stale
// for long; invalidateQueries after a save still refetches at once.
const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         staleTime: 20_000,
         // A refusal (401/403/404) will not change on the 2nd try — retrying
         // only floods the console (Ray's prod, 2026-10-18).
         retry: (count, err: any) => {
            const st = err?.response?.status;
            if (st === 401 || st === 403 || st === 404) return false;
            return count < 3;
         },
      },
   },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
   <React.StrictMode>
      <QueryClientProvider client={queryClient}>
         <App />
      </QueryClientProvider>
   </React.StrictMode>
);
